module.exports = __webpack_public_path__ + "img/CoGCa.09bacff0.png";